/**
 * AssessLayout — the candidate-facing frame: a navy YES! Automotive bar with
 * a red brand stripe, one centred column, and a quiet footer. No sidebar,
 * no Innu chrome; the candidate is on a phone, not in the Shell.
 */
import type { ReactNode } from 'react';

export function AssessLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-page text-gray-900">
      <header className="bg-navy text-white">
        <div className="mx-auto flex h-14 max-w-md items-center px-4">
          {/* Sora ships at 400/700 only (index.html), so the wordmark uses exactly those. */}
          <span className="font-brand text-[17px] font-normal tracking-tight">
            <span className="font-bold">YES!</span> Automotive
          </span>
        </div>
        <div className="h-1 bg-accent" aria-hidden />
      </header>
      <main id="main" className="mx-auto w-full max-w-md flex-1 px-4 pb-10 pt-6 sm:pt-10">
        {children}
      </main>
      <footer className="px-4 pb-6 text-center text-[12px] text-muted">
        Hiring at YES! Automotive · Questions? Reply to the text that brought you here.
      </footer>
    </div>
  );
}

/** White panel used by every page state so the eye lands in the same place. */
export function AssessPanel({ children, labelledBy }: { children: ReactNode; labelledBy?: string }) {
  return (
    <section aria-labelledby={labelledBy} className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
      {children}
    </section>
  );
}

export const primaryButtonClass =
  'inline-flex min-h-12 w-full items-center justify-center rounded-lg bg-navy px-5 text-[15px] font-semibold text-white hover:bg-navy-dark disabled:opacity-50 sm:w-auto';
